import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { Card, Button, Modal, Form, InputGroup, Row, Col } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import { Grid, FormControl, Select, InputLabel, MenuItem, makeStyles, Typography } from "@material-ui/core";
import * as Admin from "../store/ducks/admin.duck";
import { Formik } from "formik";
import * as Yup from "yup";
import Tooltip from "@material-ui/core/Tooltip";
import { ToastContainer, Flip } from "react-toastify";
import CopyIcon from "@material-ui/icons/FileCopyOutlined";
import BookingOutcome from "./BookingOutcome";
import Alert from "@material-ui/lab/Alert";
// import { saveAs } from 'file-saver';
import "react-toastify/dist/ReactToastify.css";
import "../../_metronic/_assets/css/app2.css";
import { render } from "sass";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

export default function BookingApproval(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const providerBookingApproval = useSelector((state) => state.admin.ProviderBookingApproval);
  const providerNonCSBookingApproval = providerBookingApproval ? providerBookingApproval.filter((booking) => booking.contractId !== "15") : [];
  const providerCSBookingApproval = providerBookingApproval ? providerBookingApproval.filter((booking) => booking.contractId == "15") : [];
  const filters = useSelector((state) => state.admin.Filters);
  const [searchTerm, setSearchTerm] = useState("");
  const [showBooking, setShowBooking] = useState(false);
  const [showBookingInvoice, setShowBookingInvoice] = useState(false);
  const [booking, setBooking] = useState();
  const [clientName, setClientName] = useState();
  const [viewOnlyMode, setViewOnlyMode] = useState(false);
  const [showAttendanceDialog, setShowAttendanceDialog] = useState(false);
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

  useEffect(() => {
    dispatch(Admin.actions.fetchProviderBookingApproval());
  }, [dispatch]);

  const searchProviderBookingApproval = (billableIntent) => {
    if (
      true &&
      ((billableIntent) => billableIntent.clientName.toLowerCase().search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0) &&
      (!filters.providerInvoicedStatus || filters.providerInvoicedStatus === "All" || billableIntent.rhcinvoiced === filters.providerInvoicedStatus)
    ) {
      return billableIntent;
    }
  };

  const styles = {
    card: {
      border: 0,
      borderRadius: 10,
      height: "100%",
    },

    statisticsCard: {
      border: 0,
      borderRadius: 10,
      background: "#f7f8fb",
    },

    heading: {
      fontSize: 15,
      fontWeight: 600,
      color: "#23395d",
      marginBottom: 15,
    },

    cardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 12,
    },

    controlButton: {
      width: "100%",
      border: 0,
      color: "#fff",
      fontWeight: 600,
      marginBottom: 9,
      height: 40,
      borderRadius: 6,
    },

    activeTab: {
      border: 0,
      borderRadius: 20,
      background: "#5c5de0",
      color: "#fff",
      marginRight: 6,
      fontWeight: 600,
    },

    inactiveTab: {
      border: 0,
      borderRadius: 20,
      background: "#edf0f6",
      color: "#68748a",
      fontWeight: 600,
    },

    featureBox: {
      background: "#fffaf0",
      border: "1px solid #ead9a7",
      borderRadius: 10,
      padding: 20,
      minHeight: 260,
      display: "flex",
      flexDirection: "column",
    },

    date: {
      color: "#8490a0",
      fontSize: 11,
    },

    featureTitle: {
      color: "#26395d",
      fontSize: 20,
      marginTop: 15,
      marginBottom: 8,
    },

    featureText: {
      color: "#68748a",
      fontSize: 14,
      lineHeight: 1.6,
    },

    link: {
      color: "#535ce4",
      textDecoration: "none",
      fontSize: 13,
      fontWeight: 500,
    },
  };

  const fileUploadValidationSchema = Yup.object().shape({
    BookingInvoiceFile: Yup.mixed()
      .required("Please select a file.")
      .test(
        "fileSize",
        "We can't accept this file format. Please choose a valid image or document (PDF, JPEG, PNG, IMG, HEIC, HEIF or Plain text) under 5MB.",
        (file) => {
          if (!file) return true;
          return file.size <= MAX_FILE_SIZE;
        },
      )
      .test(
        "fileType",
        "We can't accept this file format. Please choose a valid image or document (PDF, JPEG, PNG, IMG, HEIC, HEIF or Plain text) under 5MB.",
        (file) => {
          if (!file) return true;

          const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg", "image/heic", "image/heif", "text/plain"];

          const allowedExtensions = [".pdf", ".jpeg", ".jpg", ".png", ".img", ".heic", ".heif", ".txt"];

          const fileName = file.name.toLowerCase();

          return allowedTypes.includes(file.type) || allowedExtensions.some((extension) => fileName.endsWith(extension));
        },
      ),
  });

  const filteredProviderBookingApproval =
    props.approvalType === "Standard"
      ? providerNonCSBookingApproval.filter((billableIntent) => searchProviderBookingApproval(billableIntent))
      : providerCSBookingApproval.filter((billableIntent) => searchProviderBookingApproval(billableIntent));

  // const updateBooking = (thisBooking) => {
  //   setViewOnlyMode(false);
  //   setBooking(thisBooking);
  //   setClientName(thisBooking.clientName);
  //   setShowBooking(true);
  // };

  // const viewNote = (thisBooking) => {
  //   setViewOnlyMode(true);
  //   setBooking(thisBooking);
  //   setClientName(thisBooking.clientName);
  //   setShowBooking(true);
  // };

  // const approveBooking = (thisBooking) => {
  //   //
  //   setViewOnlyMode(false)
  //   dispatch(Admin.actions.putApproveBooking({ id: thisBooking.id, atype: 'A'}))
  // }

  const noShowBooking = (thisBooking) => {
    //
    setViewOnlyMode(false);
    dispatch(Admin.actions.putApproveBooking({ id: thisBooking.id, atype: "N" }));
  };

  // const unapproveBooking = (thisBooking) => {
  //   //
  //   setViewOnlyMode(false)
  //   dispatch(Admin.actions.putApproveBooking({ id: thisBooking.id, atype: 'U'}))
  // }

  const uploadInvoice = (thisBooking) => {
    //
    setClientName(thisBooking.clientName);
    setBooking(thisBooking);
    setShowBookingInvoice(true);
  };

  const copyInvoiceText = async (thisBooking) => {
    //
    console.log("This booking:", thisBooking);
    let contractName = thisBooking.service;
    if (thisBooking.contractId === "11") {
      contractName = "NthQLDPHN";
    } else if (thisBooking.contractId === "15") {
      contractName = "Centralised Service";
    }
    const invoiceStandardText =
      `Booking ID: ${thisBooking.id}\n` +
      `Client Initials: ${thisBooking.clientInitials}\n` +
      `Date: ${thisBooking.bookingDate}\n` +
      `Duration: ${thisBooking.duration}\n` +
      `Type: ${contractName}\n` +
      `Attendance: ${thisBooking.status}\n` +
      `Fee: ${thisBooking.providerfee}\n` +
      `Session Code: ${thisBooking.bookingCode}\n` +
      `Session Type: ${thisBooking.bookingCodeDescription}\n`;
    const invoiceReportText =
      `Booking ID: ${thisBooking.id}\n` +
      `Client Initials: ${thisBooking.clientInitials}\n` +
      `Date: ${thisBooking.bookingDate.split(" ")[0]}\n` +
      `Type: ${contractName}\n` +
      `Fee: ${thisBooking.providerfee}\n` +
      `Session Code: ${thisBooking.bookingCode}\n` +
      `Session Type: Report: ${thisBooking.reportType}\n`;
    // Need to determine if it is a standard invoice or a report invoice by session code
    let invoiceText = "";
    if (["S0112", "S0113", "S0114", "S0212", "S0213", "S0214"].includes(thisBooking.bookingCode)) {
      invoiceText = invoiceReportText;
    } else {
      invoiceText = invoiceStandardText;
    }
    try {
      await navigator.clipboard.writeText(invoiceText);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const rhcInvoicedBooking = (thisBooking) => {
    //
    dispatch(Admin.actions.putRHCInvoicedBooking({ id: thisBooking.id }));
  };

  const markAttendanceBooking = (thisBooking) => {
    setBooking(thisBooking);
    setShowAttendanceDialog(true);
  };

  const validationSchema = Yup.object().shape({
    note: Yup.string().min(2, "Too Short").max(3800, "Too Long"),
  });

  function submitForm(data) {
    // Save data
    dispatch(Admin.actions.putBookingNote({ id: data.id, note: data.note }));
    setShowBooking(false);
  }

  function submitBookingInvoiceForm(data) {
    // Save data
    const formData = new FormData();
    formData.append("BookingInvoiceFile", data.BookingInvoiceFile);
    formData.append("id", booking.id);
    dispatch(Admin.actions.postBookingInvoice({ formData: formData }));
    setShowBookingInvoice(false);
  }

  const columns = [
    {
      field: "id",
      headerName: "Booking ID",
      width: 140,
      renderCell: (params) => (
        <div>
          <Typography>
            <CopyIcon onClick={() => navigator.clipboard.writeText(params.row.id)} style={{ marginRight: 10 }} /> {params.row.id}{" "}
          </Typography>
        </div>
      ),
    },
    { field: "charged", headerName: "RHC", width: 50, hide: true },
    {
      field: "clientName",
      headerName: "Name",
      width: 150,
    },
    { field: "status", headerName: "Status", width: 110 },
    {
      field: "bookingDate",
      headerName: "Date",
      width: 150,

      valueGetter: (params) => {
        const val = params.row.bookingDate; // ✅ use row, not params.value
        if (!val) return null;

        const [datePart, timePart, meridian] = val.split(" ");
        const [day, month, year] = datePart.split("/");

        let [hours, minutes] = timePart.split(":");
        hours = parseInt(hours, 10);

        if (meridian === "PM" && hours !== 12) hours += 12;
        if (meridian === "AM" && hours === 12) hours = 0;

        return new Date(year, month - 1, day, hours, minutes);
      },

      valueFormatter: (params) => {
        return params.row.bookingDate; // ✅ original string restored
      },
    },
    { field: "duration", headerName: "Duration", width: 120, renderCell: (params) => (params.row.duration ? params.row.duration + " mins" : "") },
    { field: "contactId", headerName: "Contact ID", width: 120, hide: true },
    {
      field: "service",
      headerName: "Type",
      width: 250,
      renderCell: (params) =>
        params.row.contractId === "11" ? "NthQLDPHN" : params.row.contractId === "15" ? params.row.bookingCodeDescription : params.value,
    },
    { field: "bookingCode", headerName: "Code", width: 100, hide: props.approvalType === "Standard" ? true : false },
    { field: "providerfee", headerName: "Fee", width: 100 },
    { field: "rhcinvoiced", headerName: "Inv Uploaded", width: 150 },
    // {
    //   field: "note",
    //   headerName: "Note (Hover to View)",
    //   width: 190,
    //   renderCell: (params) => <RenderExpandableCell {...params} />,
    // },
    {
      field: "none",
      headerName: "Action",
      width: 430,
      renderCell: (params) => (
        <>
          {params.row.charged !== "Y" ? (
            <>
              {params.row.service === "Contract" && params.row.status === "Active" && params.row.contractId === "15" ? (
                <Button variant="info" size="sm" onClick={() => markAttendanceBooking(providerBookingApproval.find((intent) => intent.id === params.row.id))}>
                  Mark Attendance
                </Button>
              ) : (
                <>
                  <Tooltip title="Text to paste into your invoice">
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={() => copyInvoiceText(providerBookingApproval.find((intent) => intent.id === params.row.id))}
                      style={{
                        color: "blue",
                        fontWeight: 500,
                        border: 0,
                        background: "#eee",
                        marginRight: 14,
                      }}
                    >
                      Copy Inv Text
                    </Button>
                  </Tooltip>
                  {((params.row.service === "Contract" && (params.row.contractId === "11" || params.row.contractId === "15")) ||
                    params.row.service === "EAP") &&
                  (!params.row.fileExists || params.row.fileExists === 0) ? (
                    <>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => uploadInvoice(providerBookingApproval.find((intent) => intent.id === params.row.id))}
                        style={{
                          color: "blue",
                          fontWeight: 500,
                          border: 0,
                          background: "#eee",
                          marginRight: 14,
                        }}
                      >
                        Upload Invoice
                      </Button>
                    </>
                  ) : null}
                </>
              )}
            </>
          ) : (
            <>
              {params.row.rhcinvoiced === "No" &&
              ((params.row.service !== "Contract" && params.row.service !== "EAP") ||
                (params.row.service === "Contract" && params.row.contractId !== "11" && params.row.contractId !== "15")) ? (
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => rhcInvoicedBooking(providerBookingApproval.find((intent) => intent.id === params.row.id))}
                  style={{
                    color: "blue",
                    fontWeight: 500,
                    border: 0,
                    background: "#eee",
                    marginRight: 14,
                  }}
                >
                  Mark Invoiced
                </Button>
              ) : null}
            </>
          )}
        </>
      ),
    },
  ];

  function handleBookingClose() {
    setShowBooking(false);
  }

  function handleBookingInvoiceClose() {
    setShowBookingInvoice(false);
  }

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <Card style={{ ...styles.card, marginTop: 20 }}>
        <Card.Body>
          {/* HEADER */}
          <div style={styles.cardHeader}>
            <h5 style={styles.heading}>
              {props.approvalType === "CS"
                ? "Please mark all non-attendances immediately on the calendar booking and for CS, if necessary, advise Centre staff member directly."
                : props.approvalType === "Standard"
                  ? "Review NDIS, Contract and EAP Bookings"
                  : null}
            </h5>
          </div>

          {/* INFORMATION */}
          {props.approvalType === "Standard" ? (
            <Alert
              severity="info"
              style={{
                fontSize: 14,
                width: "100%",
                marginBottom: 15,
              }}
            >
              <ul style={{ marginBottom: 0 }}>
                <li>
                  <p style={{ marginBottom: 0 }}>For NDIS Clients - please send your own invoice.</p>
                </li>
                {/* <li>
              <p>For EAP Clients - RHC will pay you. No invoice needed.</p>
            </li> */}
              </ul>
            </Alert>
          ) : null}

          {/* SEARCH / FILTERS */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginBottom: 15,
            }}
          >
            <div style={{ width: 250 }}>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                  </InputGroup.Text>
                </InputGroup.Prepend>

                <Form.Control type="text" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" style={{ height: 33 }} />
              </InputGroup>
            </div>

            <div>
              <FormControl variant="outlined" className={classes.formControl} size="small">
                <InputLabel id="providerInvoicedStatus-label" className={classes.label}>
                  Invoiced Status
                </InputLabel>

                <Select
                  labelId="providerInvoicedStatus-label"
                  id="providerInvoicedStatus"
                  margin="dense"
                  style={{
                    minWidth: 120,
                    backgroundColor: "#ffffff",
                    height: 33,
                  }}
                  value={filters.providerInvoicedStatus}
                  onChange={(event) =>
                    dispatch(
                      Admin.actions.setFilters({
                        filterName: "providerInvoicedStatus",
                        filterValue: event.target.value,
                      }),
                    )
                  }
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Yes">Invoiced</MenuItem>
                  <MenuItem value="No">Outstanding</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          {/* BOOKINGS */}
          {providerBookingApproval ? (
            <div
              style={{
                width: "100%",
                minHeight: 200,
                height: 300,
                backgroundColor: "#fff",
                borderRadius: 8,
                overflow: "hidden",
              }}
            >
              <DataGrid
                rows={filteredProviderBookingApproval}
                getRowHeight={() => "auto"}
                columns={columns}
                rowsPerPageOptions={[20]}
                pagination
                checkboxSelection={false}
                rowHeight={40}
                sortModel={[
                  {
                    field: "bookingDate",
                    sort: "desc",
                  },
                ]}
              />
            </div>
          ) : (
            <div style={{ color: "#8490a0" }}>None</div>
          )}
        </Card.Body>
      </Card>

      <Modal
        show={showAttendanceDialog}
        onHide={() => setShowAttendanceDialog(false)}
        size="lg" // "sm" | "lg" | "xl"
        dialogClassName="note-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Booking with {booking && booking.clientName ? booking.clientName : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <BookingOutcome
            name={booking && booking.clientName ? booking.clientName : ""}
            start={booking && booking.psychologistDate ? booking.psychologistDate : null}
            status={booking && booking.status ? booking.status : ""}
            clientID={booking && booking.clientid ? booking.clientid : null}
            bookingID={booking && booking.bookingid ? booking.bookingid : null}
            paymentType={booking && booking.service ? booking.service : ""}
            psychologistID={booking && booking.psychologistid ? booking.psychologistid : null}
            closeModal={setShowAttendanceDialog}
            attendanceStatus={booking && booking.days ? booking.days : null}
            source="Approval"
          />
        </Modal.Body>
      </Modal>

      <Modal show={showBooking} onHide={handleBookingClose} dialogClassName="edit-tags-modal">
        <Modal.Header closeButton className="edit-tags-modal">
          <Modal.Title>Update Booking - {clientName} </Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}
          initialValues={booking}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => {
            submitForm(values);
          }}
        >
          {(props) => {
            const { values, errors, handleChange, handleSubmit } = props;
            const change = (name, e) => {
              e.persist();
              handleChange(e);
            };
            return (
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Modal.Body className="edit-tags-modal">
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Update Booking Note for Invoicing Purposes </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          type="text"
                          name="note"
                          value={values.note}
                          onChange={change.bind(null, "note")}
                          autoComplete="new-password"
                          style={{ borderColor: "#D1D1D1" }}
                        />
                        {errors ? <p className="error-help">{errors.note}</p> : ""}
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="edit-tags-modal">
                  <Grid container justifyContent="space-between">
                    <Grid item></Grid>
                    <Grid item>
                      <Button variant="secondary" onClick={handleBookingClose}>
                        Cancel
                      </Button>
                      {!viewOnlyMode ? (
                        <Button variant="primary" type="submit" style={{ marginLeft: 8 }}>
                          Save
                        </Button>
                      ) : null}
                    </Grid>
                  </Grid>
                </Modal.Footer>
              </form>
            );
          }}
        </Formik>
      </Modal>

      <Modal show={showBookingInvoice} onHide={handleBookingInvoiceClose} dialogClassName="edit-tags-modal">
        <Modal.Header closeButton className="edit-tags-modal">
          <Modal.Title>
            Upload Invoice for Booking ID - {booking && booking.id} - {clientName}{" "}
          </Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}
          initialValues={{ BookingInvoiceFile: "" }}
          validationSchema={fileUploadValidationSchema}
          onSubmit={(values, actions) => {
            submitBookingInvoiceForm(values);
          }}
        >
          {(props) => {
            const { errors, handleChange, handleSubmit, touched, setFieldValue } = props;
            const change = (name, e) => {
              e.persist();
              handleChange(e);
            };
            return (
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Modal.Body className="edit-tags-modal">
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Control
                          type="file"
                          name="BookingInvoiceFile"
                          accept=".pdf,.jpeg,.jpg,.png,.img,.heic,.heif,.txt,text/plain,application/pdf,image/jpeg,image/png,image/jpg,image/heic,image/heif"
                          onChange={(event) => setFieldValue("BookingInvoiceFile", event.currentTarget.files[0])}
                          isInvalid={touched.BookingInvoiceFile && !!errors.BookingInvoiceFile}
                          isValid={touched.BookingInvoiceFile && !errors.BookingInvoiceFile}
                          className="form-control"
                          style={{
                            paddingTop: 6,
                            paddingLeft: 6,
                            minWidth: 200,
                            maxWidth: 300,
                          }}
                        />
                        <Form.Text className="text-muted">Accepted formats PDF, JPEG, PNG, IMG, HEIC, HEIF or Plain text under 5mb.</Form.Text>
                        <Form.Control.Feedback type="invalid">{errors.BookingInvoiceFile}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="edit-tags-modal">
                  <Grid container justifyContent="space-between">
                    <Grid item></Grid>
                    <Grid item>
                      <Button variant="secondary" onClick={handleBookingInvoiceClose}>
                        Cancel
                      </Button>
                      <Button variant="primary" type="submit" style={{ marginLeft: 8 }}>
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </Modal.Footer>
              </form>
            );
          }}
        </Formik>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
